import { Component, Element, h, Host, Listen, Prop, State } from "@stencil/core";

import { debounce } from "../../utils/debounce";

@Component({
    tag: "ux-steps",
    styleUrl: "steps.scss",
    shadow: false
})
export class Steps {
    @Element() element: HTMLUxStepsElement;

    /** this value is representing the current active step */
    @Prop() readonly current: number = 0;
    /** this value is representing number of steps */
    @Prop() readonly items: number = 0;

    /**
     * creates step-items
     * @param {Number} n number of items in indicator
     */
    private createSteps(n: number) {
        const stepElements = [];
        for (let i = 1; i < n + 1; i++) {
            stepElements.push(<ux-steps-item number={i} current={i === this.current} done={i < this.current} />);
        }
        return stepElements;
    }

    componentDidLoad() {
        this.getBottomGutter();
    }

    @Listen("resize", { target: "window" })
    onResize() {
        this.updateBottomGutter();
    }

    private updateBottomGutter = debounce(() => {
        this.getBottomGutter();
    }, 200);

    @State() bottomGutter = 0;

    private getBottomGutter = () => {
        const stepTexts = this.element.querySelectorAll(".ux-steps-item__text");
        if (stepTexts.length === 0) {
            return;
        }
        const heights: number[] = [];
        stepTexts.forEach((stepText) => {
            const height = stepText.getBoundingClientRect().height;
            heights.push(height + (height > 0 ? 10 : 0));
        });
        this.bottomGutter = Math.max(...heights);
    };

    render() {
        const baseClass = "ux-steps";
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--generated`]: this.items > 0
                }}
                style={{ paddingBottom: `${this.bottomGutter}px` }}
            >
                <div class={`${baseClass}__outer-line ${baseClass}__outer-line--left `}></div>
                <div class={`${baseClass}__indicators`}>
                    {this.createSteps(this.items)}
                    <slot />
                </div>
                <div class={`${baseClass}__outer-line ${baseClass}__outer-line--right `}></div>
            </Host>
        );
    }
}
